import { questionMatchesSteps } from "../../Settings/Components/TagFilterUtils";

/**
 * Set of questionIds (from a reportingQuestionsMap) whose own tags satisfy
 * the active TagFilterBar `filterSteps`. Returns `null` when no tag filter
 * is active, meaning "everything matches" — callers should treat `null`
 * as a pass-through rather than an empty set.
 */
export const getMatchingQuestionIds = (map, filterSteps) => {
  if (!filterSteps?.some((s) => s.values?.size)) return null;
  const matching = new Set();
  Object.values(map).forEach((q) => {
    if (questionMatchesSteps({ tags: q.tags, questionId: q.questionId }, filterSteps)) {
      matching.add(q.questionId);
    }
  });
  return matching;
};

/**
 * Whether a document/batch's relevant KPI ids intersect the matching set —
 * `questionId` once a specific question is known (qualitative, or a
 * reviewed quantitative answer), otherwise its broader `kpiIds`/
 * `actualKpiIds` (quantitative evidence not yet tied to one saved answer).
 */
export const matchesTagFilter = (entity, matchingQuestionIds) => {
  if (matchingQuestionIds === null) return true;
  const relevantIds = entity.questionId != null
    ? [entity.questionId]
    : (entity.kpiIds || entity.actualKpiIds || []);
  return relevantIds.some((id) => matchingQuestionIds.has(id));
};
